/**
 * Centralized fetch utility wrapper that mimics the `axios` API signature.
 * Extensible for future dynamic logic (e.g., token injection, logging, retries).
 */

const parseResponseData = async (response) => {
  const textData = await response.text();
  if (!textData) return null;

  try {
    return JSON.parse(textData);
  } catch {
    return textData;
  }
};

const isPlainObject = (val) => Object.prototype.toString.call(val) === '[object Object]';

const request = async (method, url, data, config = {}) => {
  const { headers: customHeaders = {}, ...restConfig } = config;
  const headers = { ...customHeaders };
  let body;

  if (data !== undefined) {
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;

    if (isFormData) {
      body = data;
      // Let the browser set Content-Type with the correct multipart boundary
      delete headers['Content-Type'];
    } else if (isPlainObject(data)) {
      body = JSON.stringify(data);
      headers['Content-Type'] ??= 'application/json';
    } else {
      body = data;
    }
  }

  const response = await fetch(url, {
    method,
    headers,
    body,
    ...restConfig,
  });

  const responseData = await parseResponseData(response);

  if (!response.ok) {
    const error = new Error(`HTTP Error ${response.status} for ${method} ${url}`);
    error.response = {
      url,
      status: response.status,
      headers: Object.fromEntries(response.headers.entries()),
    };
    throw error;
  }

  return {
    status: response.status,
    data: responseData,
    headers: Object.fromEntries(response.headers.entries()),
  };
};

const apiClient = {
  post: (url, data, config) => request('POST', url, data, config),
  get: (url, config) => request('GET', url, undefined, config),
};

export default apiClient;
